import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexRequestTypes,
  ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexResponseTypes,
} from "~/domains";

type RequestDataType = {
  employeeId: string;
  params: ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexRequestTypes;
};

const request = async ({
  employeeId,
  params,
}: RequestDataType): Promise<ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexResponseTypes> => {
  const response =
    await new ApiClient().get<ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexResponseTypes>(
      `/api/analytics_plans/employees/${employeeId}/meeting_note_calendars`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params: ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexRequestTypes;
  employeeId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndex = ({
  params,
  employeeId,
  config = {},
}: PropsType): UseQueryResult<ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndexResponseTypes> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisAnalyticsPlansEmployeesMeetingNoteCalendarsIndex",
      employeeId,
      params,
    ],
    queryFn: () => request({ employeeId, params }),
  });
};
